import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: '', 
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      // localStorage.removeItem('token'); // Optional: clean up
      // window.location.href = '/login';  // Redirect to login
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
